<div class="card-layout" *hasPermission="['READ', 'maintenance']">
  <button class="lign-card-maintenance" (click)="clickMaintenance(maintenance.uid)">
    <div>
      <i class="material-icons icon-maintenance {{ maintenance.maintenance_color_icon }}">build</i>
    </div>

    <div class="content-card-maintenance">
      <div class="title-card-maintenance">
        <p class="maint-name">
          {{ maintenance.motif }}
        </p>
        @if (!!maintenance.uid_sensor) {
          <p class="maint-detail">
            {{ maintenance.registration }} - {{ 'TRIP.SENSOR' | translate }} :
            {{ $sensors[maintenance.uid_sensor].summary }}
          </p>
        } @else {
          <p class="maint-detail">
            {{ maintenance.registration }}
          </p>
        }
      </div>

      <div class="params-card-maintenance">
        <div class="params-right">
          <div>
            @if (maintenance.maintenance_type_km) {
              <span class="param-detail">
                {{ maintenance.deadline_km / 1000 | imperial: 'distance' : 0 }}
              </span>
            }
            @if (maintenance.maintenance_type_km && maintenance.maintenance_type_engine) {
              <span class="param-detail">-</span>
            }
            @if (maintenance.maintenance_type_engine) {
              <span class="param-detail">
                {{ maintenance.deadline_engine * 1000 | duration }}
              </span>
            }
          </div>
          @if (maintenance.maintenance_type_cal) {
            <div class="param-detail">
              {{ maintenance.deadline_cal * 1000 | dynamicDate: 'shortDate' }}
            </div>
          }
        </div>
      </div>
    </div>
  </button>
</div>
